
export default {
  data() {
    return {
      title: this.$t('termsConditions'),
      description: this.$t('platformDescription'),
    };
  },
  head() {
    return {
      title: this.title,
      meta: [
        { hid: "description", name: "description", content: this.description },
        { hid: "og:locale", property: "og:locale", content: "ar_AR" },
        { hid: "og:type", property: "og:type", content: "article" },
        { hid: "og:title", property: "og:title", content: this.title },
        { hid: "og:description", property: "og:description", content: this.description },
        { hid: "og:url", property: "og:url", content: "https://matjrah.com/terms-and-conditions" },
        { hid: "og:site_name", property: "og:site_name", content: "متجرة" },
        { hid: "og:updated_time", property: "og:updated_time", content: "2022-12-10T00:08:47+03:00" },
        { hid: "og:image", property: "og:image", content: "https://matjrah.com/matjrah.png" },
        { hid: "apple-mobile-web-app-title", name: "apple-mobile-web-app-title", content: this.title },

        // open graph twitter
        { name: "twitter:site", content: "@Matjrah" },
        { name: "twitter:card", content: "summary_large_image" },
        { hid: "twitter:url", name: "twitter:url", content: "https://matjrah.com/terms-and-conditions" },
        { hid: "twitter:title", name: "twitter:title", content: this.title },
        { hid: "twitter:description", name: "twitter:description", content: this.description },
        { hid: "twitter:image", name: "twitter:image", content: "https://matjrah.com/matjrah.png" },
      ],
      link: [{ rel: "canonical", href: "https://matjrah.com/terms-and-conditions" }],
    };
  },
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Article",
          "headline": this.$t('termsConditionsMatjrah'),
          "description": this.description,
          "datePublished": "2022-10-14T10:10:00-07:00",
          "dateModified": "2022-10-14T10:10:00-07:00",
          "publisher": {
            "@type": "Organization",
            "name": "منصة متجرة",
            "logo": { "@type": "ImageObject", "url": "https://matjrah.com/matjrah.png" },
          },
          "mainEntityOfPage": { "@type": "WebPage", "@id": "https://matjrah.com/terms-and-conditions" },
          "author": { "@type": "Person", "name": "matjrah" },
        },
      ],
    };
  },
};
